module.exports = __webpack_public_path__ + "media/app/assets/images/DPReview-logo-6633f2a703160cefb43c60f05fbadfe5.png";